import { render, staticRenderFns } from "./ViewTransLimitDetails.vue?vue&type=template&id=9e2deac0&scoped=true"
import script from "./ViewTransLimitDetails.vue?vue&type=script&lang=js"
export * from "./ViewTransLimitDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewTransLimitDetails.vue?vue&type=style&index=0&id=9e2deac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2deac0",
  null
  
)

export default component.exports